<template>
  <div class="home">
    <div class="swiper">
      <swiper   v-if="banners.length" :options="swiperOption">
        <swiper-slide v-for="(item, index) in banners" :key="index">
          <img
            class="banner"
            @click="tobanner(item)"
            :src="imgserver + item.thumb"
            mode="scaleToFill"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="notice">
      <div class="notice_main" @click="looknews(bulletinVo.messageId)">
        学会公告：
        <span class="notice_title">{{ bulletinVo.title }}</span>
        <span class="notice_time">{{ bulletinVo.publishDate }}</span>
      </div>
      <div class="title_more" @click="tolookmore">查看更多</div>
    </div>
    <div class="online_news">
      <div class="online">
        <img class="online_img" src="../assets/image/exonline.png" alt="" />
        <div class="online_imgbox">
          <el-carousel
            :autoplay="false"
            indicator-position="none"
            type="card"
            height="331rem"
          >
            <el-carousel-item v-for="item in pavilionVos" :key="item">
              <img
                @click="changeonline(item)"
                style="width: 100%; height: 100%"
                :src="imgserver + item.thumb"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="news">
        <div class="news_header">
          <img class="news_img" src="../assets/image/news.png" alt="" />
          <div class="news_more" @click="tolookmorenews">查看更多</div>
        </div>
        <div class="news_ul">
          <div
            class="news_li"
            v-for="(item, index) in societyVos"
            :key="index"
            @click="tolooksociety(item.messageId)"
          >
            <div class="news_dot">
              <img src="../assets/image/dot.png" />
              <div class="news_title">
                {{ item.title }}
              </div>
            </div>
            <div class="news_time">[ {{ item.publishDate }} ]</div>
          </div>
        </div>
      </div>
    </div>
    <div class="speech">
      <div class="speech_left">
        <img src="../assets/image/speech.png" class="speech_img" alt="" />
        <div class="speechmain">
          <img class="speechmainimg" :src="imgserver + speech.thumb" alt="" />
          <div class="speech_content" v-html="speech.content"></div>
        </div>

        <div class="speech_detail" @click="lookdetail()">查看详情</div>
      </div>
      <!-- <div class="speech_right">
       
      </div> -->
    </div>
  </div>
</template>
 
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      banners: [],
      bulletinVo: {},
      links: [],
      pavilionVos: [],
      societyVos: [],
      speech: {},
      swiperOption: {
        autoplay: {
        delay: 3000, // 轮播间隔时间，单位为毫秒
        disableOnInteraction: false, // 用户操作后是否停止自动轮播，默认为 true
        },
        loop:true,
        pagination: {
          el: ".swiper-pagination", // 分页器容器
        },
      },
      currentPage: 0, // 当前页面
      totalButtons: 0, // 总按钮数
      buttonsPerPage: 3, // 每页显示的按钮数
    };
  },
  created() {},

  mounted() {
    this.$http
      .get(`/api/home/getWebBanner`)
      .then((response) => {
        window.console.log(response);
        //轮播图
        this.banners = response.data.data.banners;
        //学会公告
        this.bulletinVo = response.data.data.bulletinVo;
        //链接
        this.links = response.data.data.links;
        window.console.log(this.banners);
      })
      .catch((e) => {
        this.$message({
          message: "网络或程序异常！" + e,
          type: "error",
        });
      });
    this.$http
      .get(`/api/home/getWebSituation`)
      .then((response) => {
        window.console.log(response);
        //展馆在线
        this.pavilionVos = response.data.data.pavilionVos.slice(0,4);
        //学会资讯
        this.societyVos = response.data.data.societyVos;
        //理事长致辞
        this.speech = response.data.data.speech;
        window.console.log(this.pavilionVos,'1231');
      })
      .catch((e) => {
        this.$message({
          message: "网络或程序异常！" + e,
          type: "error",
        });
      });
  },
  methods: {
    tolookmore() {
      this.$router.push({ path: "/news", query: { id: 2 } });
    },
    tolookmorenews() {
      this.$router.push({ path: "/news", query: { id: 1 } });
    },
    looknews(id) {
      this.$router.push({ path: "/news", query: { id: 2, mid: id } });
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
    },
    prevSlide() {
      this.currentIndex =
        (this.currentIndex - 1 + this.items.length) % this.items.length;
    },
    lookdetail() {
      this.$router.push({ path: "/overview", query: { id: 5 } });
    },
    tolooksociety(id) {
      this.$router.push({ path: "/news", query: { id: 1, mid: id } });
    },
    tobanner(item) {
      window.console.log(item);
      window.open(item.outerUrl);
    },
    prevPage() {
      window.console.log(this.currentPage, this.totalButtons);
      if (this.currentPage > 0) {
        this.currentPage--;
      }
      window.console.log(this.currentPage);
    },

    nextPage() {
      window.console.log(this.currentPage, this.totalButtons);
      if (this.currentPage < this.totalButtons) {
        this.currentPage++;
      }
      window.console.log(this.currentPage);
    },
    changeonline(e) {
      window.console.log(e);
      this.$router.push({
        path: "/Online",
        query: { id: e.typeMgtId, pid: e.pavilionId },
      });
    },
  },
};
</script>
 <style lang="scss" >
.speech_content{
  img{
    width: 100%;
  }
}
.swiper-pagination {
  position: absolute;
  bottom: 40rem !important;
  left: initial;
  right: 40rem;
  .swiper-pagination-bullet {
    width: 21rem;
    height: 21rem;
    background: #ffffff;
    opacity: 1; /* 圆点不选中时的透明度 */
    margin: 0 3rem; /* 圆点间距 */
    border-radius: 50%; /* 圆点形状 */
  }
  .swiper-pagination-bullet-active {
    background: #871c1f;
  }
}
</style>
<style lang="scss" scoped>
.home {
  width: 100%;
  background: #f5f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 64rem;
}
.swiper {
  width: 1877rem;
  height: 576rem;
  .swiper-slide {
    width: 1877rem;
    height: 576rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.banner {
  width: 1877rem;
  height: 533rem;
  cursor: pointer;
}
.notice {
  width: 1493rem;
  height: 85rem;
  padding: 0 21rem;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 0rem 0rem 0rem 0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .notice_main {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 19rem;
    color: #8e8e93;
    line-height: 27rem;
    cursor: pointer;
    .notice_title {
      color: #3d3d3d;
      max-width: 600rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .notice_time {
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 19rem;
      color: #8e8e93;
      margin-left: 23rem;
    }
  }
  .title_more {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 19rem;
    color: #871c1f;
    cursor: pointer;
  }
}
.online_news {
  display: flex;
  justify-content: space-between;
  width: 1493rem;
  margin-top: 21rem;
  .online {
    width: 736rem;
    height: 453rem;
    background: #ffffff;
    border-radius: 0rem 0rem 0rem 0rem;
    .online_img {
      width: 96rem;
      height: 43rem;
      margin: 21rem 0 0 21rem;
    }
    .online_imgbox {
      width: 736rem;
      height: 331rem;
      // background: #871c1f;
      margin-top: 32rem;
      display: flex;
      justify-content: center;
      align-items: center;
      .someimg {
        display: flex;
        .organization_main {
          border: 1rem solid #2c2c2e;
          width: 608rem;
          display: flex;
        }
        .nocenter {
          justify-content: space-between;
        }
        .center {
          justify-content: center;
        }
        .prevpage {
          width: 64rem;
          height: 64rem;
        }
      }
    }
  }
  .news {
    width: 736rem;
    height: 453rem;
    background: #ffffff;
    border-radius: 0rem 0rem 0rem 0rem;
    overflow: hidden;
    .news_header {
      display: flex;
      padding: 21rem 21rem 0;
      box-sizing: border-box;
      justify-content: space-between;
    }
    .news_img {
      width: 96rem;
      height: 43rem;
    }
    .news_more {
      width: 133rem;
      height: 43rem;
      border-radius: 0rem 0rem 0rem 0rem;
      border: 1rem solid #871c1f;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 19rem;
      color: #871c1f;
      line-height: 43rem;
      text-align: center;
      cursor: pointer;
    }
    .news_ul {
      width: 736rem;
      padding: 0 21rem;
      box-sizing: border-box;
      .news_li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 21rem;
        cursor: pointer;
        .news_dot {
          display: flex;
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 400;
          font-size: 19rem;
          color: #2c2c2e;
          width: 422rem;
          .news_title {
            width: 400rem;
            overflow: hidden; /*超出的部分隐藏起来。*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出文本以省略号显示 */
          }

          img {
            height: 20rem;
            height: 20rem;
            margin-top: 3rem;
          }
        }
        .news_time {
          font-family: Source Han Sans, Source Han Sans;
          font-weight: 400;
          font-size: 19rem;
          color: #c7c7cc;
        }
      }
    }
  }
}
.speech {
  position: relative;
  width: 1493rem;
  background: #ffffff;
  border-radius: 0rem 0rem 0rem 0rem;
  margin-top: 21rem;
  padding: 21rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  .speech_img {
    width: 120rem;
    height: 43rem;
  }
  .speech_title {
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 700;
    font-size: 19rem;
    color: #3d3d3d;
    margin-top: 25rem;
  }
  .speechmain {
    width: 1450rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    .speechmainimg {
      width: 241rem;
      height: 355rem;
      position: absolute;
      right: 21rem;
      top: -42rem;
    }
    .speech_content {
      width: 1067rem;
      min-height: 285rem;
      font-family: Source Han Sans, Source Han Sans;
      font-weight: 400;
      font-size: 19rem;
      color: #3d3d3d;
      margin-top: 11rem;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 7;
      // -webkit-box-orient: vertical;
    }
  }

  .speech_detail {
    width: 133rem;
    height: 43rem;
    border-radius: 0rem 0rem 0rem 0rem;
    border: 1rem solid #871c1f;
    font-family: Source Han Sans, Source Han Sans;
    font-weight: 400;
    font-size: 19rem;
    color: #871c1f;
    line-height: 43rem;
    text-align: center;
    margin-top: 21rem;
    cursor: pointer;
  }
  .speech_right {
    img {
      width: 241rem;
      height: 355rem;
      border-radius: 0rem 0rem 0rem 0rem;
    }
  }
}
.el-carousel {
  width: 608rem;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>